var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCarrotUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00345 0.975912C6.17617 0.975912 6.34888 1.04408 6.46632 1.17359L11.8135 6.57918C11.9309 6.69507 12 6.84503 12 7.01545C12 7.36991 11.7306 7.64258 11.3713 7.64258C11.1986 7.64258 11.0397 7.57441 10.9223 7.46535L6.00345 2.50284L1.07772 7.46535C0.967185 7.57441 0.80829 7.64258 0.62867 7.64258C0.26943 7.64258 0 7.36991 0 7.01545C0 6.84503 0.0690846 6.69507 0.186529 6.57237L5.53368 1.17359C5.66494 1.04408 5.82383 0.975912 6.00345 0.975912Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCarrotUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/carrot-up.a7d88fba2991ccb6d16f077731ec72de.svg";